export const ERROR_TYPE_SERVER = 'server';
export const ERROR_TYPE_RENDER = 'render';
export const ERROR_TYPE_BLANK = 'blank';
